import { render, staticRenderFns } from "./TraceHistory.vue?vue&type=template&id=ffd90204&scoped=true&"
import script from "./TraceHistory.vue?vue&type=script&lang=js&"
export * from "./TraceHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffd90204",
  null
  
)

export default component.exports